module.exports = __webpack_public_path__ + "img/calendar-month-fill.33fc44a0.svg";